import { Component } from '@angular/core';

@Component({
    selector: 'flow-thinking-indicator',
    template: `
        <div class="thinking-dots">
            <span class="dot" style="animation-delay: 0s;"></span>
            <span class="dot" style="animation-delay: 0.2s;"></span>
            <span class="dot" style="animation-delay: 0.4s;"></span>
        </div>
    `,
    styles: [`
        .thinking-dots {
            display: flex;
            align-items: center;
            gap: 4px;
            padding: 2px 0;
        }
        .dot {
            display: inline-block;
            width: 7px;
            height: 7px;
            border-radius: 50%;
            background: #999;
            animation: flow-thinking-dot 1.2s ease-in-out infinite;
        }
    `]
})
export class ThinkingIndicatorComponent {}
